import { createContext } from 'preact';
import type { SetStateAction } from 'preact/compat';
import type { Dispatch } from 'preact/hooks';

interface VkCaptchaContextProps {
  isCaptchaShown?: boolean;
  isCaptchaPassed?: boolean;
  setIsCaptchaShown?: Dispatch<SetStateAction<boolean>>;
  setIsCaptchaPassed?: Dispatch<SetStateAction<boolean>>;
}

export const VkCaptchaContext = createContext<VkCaptchaContextProps>({});
